import React, { useState, useEffect } from 'react';
import { API } from '../../../../../API/API';
import { Panel, PanelType } from '@fluentui/react';
import Warning from '../../../../../components/Warning/Warning';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';
import FieldDropdown from '../../../../../components/FieldDropdown/FieldDropdown';
import FieldText from '../../../../../components/FieldText/FieldText';
import { message } from 'antd';
import { MessageConst } from '../../../../../const/MessageConst';
import FieldDate from '../../../../../components/FieldDate/FieldDate';
import FieldNumber from '../../../../../components/FieldNumber/FieldNumber';
import { hideLoadScreen, showLoadScreen } from '../../../../../components/LoadScreen/LoadScreen';
import FieldItemList from '../../../../../components/FieldItemList/FieldItemList';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import FieldItemListAdd from '../../../../../components/FieldItemListAdd/FieldItemListAdd';

const NewEducation = (props) => {
    const [initData, setInitData] = useState({
        "entryid": -1,
        "empid": props.empid,
        "countryid": null,
        "divisionid": null,
        "universityid": null,
        "fromdate": null,
        "todate": null,
        "professionid": null,
        "educationtypeid": null,
        "educationlevelid": null,
        "certificateno": null,
        "gpa": 0,
        "gpapercent": 0,
        "thesis": null,
        "score": null,
        "note": null
    });
    const [data, setData] = useState({ ...initData });
    const [dEducationType, setDEducationType] = useState([]);
    const [dEducationLevel, setDEducationLevel] = useState([]);
    const [warning, setWarning] = useState();

    const getInitData = async () => {

        let tDEducationType = [];
        let tDEducationLevel = [];

        showLoadScreen();

        await API.get('/api/humanresource/organization/get_educationtype_dropdown').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tDEducationType = response.data.retdata;
            }
        });

        await API.get('/api/humanresource/organization/get_educationlevel_dropdown').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tDEducationLevel = response.data.retdata;
            }
        });
        hideLoadScreen();

        setDEducationType(tDEducationType);
        setDEducationLevel(tDEducationLevel);
    }

    useEffect(() => {
        getInitData();
    }, []);

    const getExistData = async () => {
        let tData = { ...initData };
        if (props.entryid) {

            showLoadScreen();
            await API.get('/api/humanresource/employee/get_empeducation?entryid=' + props.entryid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
            hideLoadScreen();
        }

        setData(tData);
    }

    useEffect(() => {
        getExistData();
    }, [props.entryid]);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'countryid') {
                tData["divisionid"] = null;
            }
            setData(tData);
        }
    }

    const onSave = async (p_close) => {

        let vRule = true;
        if (!data.countryid) {
            vRule = false;
            setWarning("Улс" + MessageConst.fieldRequired);
        } else if (!data.universityid) {
            vRule = false;
            setWarning("Сургууль" + MessageConst.fieldRequired);
        } else if (!data.fromdate) {
            vRule = false;
            setWarning("Элссэн огноо" + MessageConst.fieldRequired);
        }

        if (vRule) {
            showLoadScreen();
            let tData = { ...data };
            tData.empid = props.empid;
            await API.post('/api/humanresource/employee/save_empeducation', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setData({ ...initData });
                    setWarning();
                    if (props.afterSave) {
                        props.afterSave(p_close);
                    }
                }
            });
            hideLoadScreen();
        }
    }
    const onDelete = async (p_close) => {
        showLoadScreen();
        await API.post('/api/humanresource/employee/delete_empeducation?entryid=' + props.entryid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                if (props.afterSave) {
                    props.afterSave(p_close);
                }
            }
        });
        hideLoadScreen();
    }

    return (
        <PanelBase
            headerText={props.entryid > 0 ? "Боловсрол засах" : "Боловсрол нэмэх"}
            isOpen={props.onOpen}
            type={PanelType.medium}
            isFooterAtBottom={true}
            onDismiss={props.onDismiss}
            onDelete={() => onDelete(true)}
            warning={warning}
            delete={props.entryid}
            buttons={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div>
                        <ButtonSecondary onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefault onClick={() => onSave(true)} text="Хадгалах" />
                    </div>
                </div>
            }
        >
            <div style={{ marginTop: 20 }}>
                <FieldItemList title="Улс" onChanged={fieldOnChanged} keyfield='countryid' keyfieldname='countryname' defaultValue={[{ key: data.countryid, name: data.countryname }]} dataurl="/api/humanresource/organization/get_country_and_division_dropdown" saveurl="/api/humanresource/organization/save_country" />
                <div style={{ marginTop: 13 }}>
                    <FieldItemList disable={data.countryid ? false : true} title="Аймаг, хот" onChanged={fieldOnChanged} keyfield='divisionid' keyfieldname='divisionname' defaultValue={[{ key: data.divisionid, name: data.divisionname }]} dataurl="api/humanresource/organization/get_division_dropdown" dataparam={[{ key: 'countryid', name: data.countryid }]} saveurl="/api/humanresource/organization/save_division" saveparam={[{ key: 'countryid', name: data.countryid }]} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemListAdd disable={data.divisionid ? false : true} title="Сургууль" onChanged={fieldOnChanged} keyfield='universityid' keyfieldname='universityname' defaultValue={[{ key: data.universityid, name: data.universityname }]} dataurl="/api/humanresource/organization/get_university_dropdown" dataparam={[{ key: 'divisionid', name: data.divisionid }]} saveurl="/api/humanresource/organization/save_university" saveparam={[{ key: 'divisionid', name: data.divisionid }]} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Элссэн огноо" onChanged={fieldOnChanged} keyfield='fromdate' defaultValue={data.fromdate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Дуусах огноо" onChanged={fieldOnChanged} keyfield='todate' defaultValue={data.todate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemList
                        title="Мэргэжлийн төрөл"
                        onChanged={fieldOnChanged}
                        keyfield='professiontypeid'
                        keyfieldname='professiontypename'
                        defaultValue={[{ key: data.professiontypeid, name: data.professiontypename }]}
                        dataurl="/api/humanresource/organization/get_profession_type_dropdown" />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldItemListAdd
                        title="Мэргэжил"
                        onChanged={fieldOnChanged}
                        keyfield='professionid'
                        keyfieldname='professionname'
                        defaultValue={[{ key: data.professionid, name: data.professionname }]}
                        dataurl="api/humanresource/organization/get_profession_dropdown"
                        dataparam={[{ key: 'professiontypeid', name: data.professiontypeid }]}
                        saveurl="/api/humanresource/organization/save_profession"
                        saveparam={[{ key: 'professiontypeid', name: data.professiontypeid }]} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Боловсролын төрөл" onChanged={fieldOnChanged} keyfield='educationtypeid' defaultValue={data.educationtypeid} data={dEducationType} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Боловсролын түвшин" onChanged={fieldOnChanged} keyfield='educationlevelid' defaultValue={data.educationlevelid} data={dEducationLevel} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldNumber title="Голч дүн" onChanged={fieldOnChanged} keyfield='gpa' defaultValue={data.gpa} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldNumber title="Голч дүн /хувиар/" onChanged={fieldOnChanged} keyfield='gpapercent' defaultValue={data.gpapercent} />
                </div>
            </div>
        </PanelBase>

    );
}

export default NewEducation;